var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_5696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.0319C11.7376 0.317367 13.2624 0.317367 14.5 1.0319L21.4317 5.0339C22.6693 5.74843 23.4317 7.06894 23.4317 8.498V16.502C23.4317 17.9311 22.6693 19.2516 21.4317 19.9661L14.5 23.9681C13.2624 24.6826 11.7376 24.6826 10.5 23.9681L3.56833 19.9661C2.33073 19.2516 1.56833 17.9311 1.56833 16.502V8.498C1.56833 7.06894 2.33073 5.74843 3.56833 5.0339L10.5 1.0319Z",
    fill: "#777E90"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.6894,
    height: 2.88928,
    rx: 0.846983,
    transform: "matrix(0.328046 -0.944662 0.944661 0.328047 8.18687 17.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5339 11.4118C18.1637 9.86939 17.1966 7.50554 13.5964 6.54677C9.99627 5.588 7.7446 6.25672 6.31133 7.29803C6.02859 7.57028 6.19359 8.05938 6.58217 8.11478C7.78491 8.28626 9.93876 8.6564 12.2275 9.35259C14.5774 10.0674 16.6923 11.2108 17.8145 11.8755C18.149 12.0736 18.5832 11.7975 18.5339 11.4118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0411 14.4258C14.6733 14.8115 13.8764 16.2344 14.2621 17.6022C14.6478 18.97 16.0707 19.767 17.4385 19.3813C18.8063 18.9956 19.6032 17.5727 19.2175 16.2049C18.8318 14.8371 17.409 14.0401 16.0411 14.4258Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_5696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolDefault);
export default __webpack_public_path__ + "static/media/pool_default.7d44b342d87e82abb65d1872d996229f.svg";
export { ForwardRef as ReactComponent };